function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M424.34,368.742c-4.142,0-7.5,3.358-7.5,7.5v16.033c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-16.033    C431.84,372.1,428.482,368.742,424.34,368.742z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M39.565,360.726c-4.142,0-7.5,3.358-7.5,7.5v32.065c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-32.065    C47.065,364.083,43.708,360.726,39.565,360.726z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M39.565,424.775c-4.142,0-7.5,3.358-7.5,7.5v0.08c0,4.142,3.358,7.46,7.5,7.46c4.142,0,7.5-3.398,7.5-7.54    C47.065,428.133,43.708,424.775,39.565,424.775z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M472.437,0H296.082c-21.816,0-39.564,17.749-39.564,39.564v216.952H39.565c-21.815,0-39.564,17.749-39.564,39.565v176.355    C0.001,494.251,17.75,512,39.565,512h384.774c21.816,0,39.564-17.749,39.564-39.564v-8.532h8.532    c21.816,0,39.564-17.749,39.564-39.564V39.564C512.001,17.749,494.252,0,472.437,0z M64.129,497H39.565    c-13.544,0-24.564-11.02-24.564-24.564V296.081c0-13.545,11.02-24.564,24.564-24.564h24.564V497z M448.904,472.436    c0,13.545-11.02,24.564-24.564,24.564h-24.564V328.148c0-4.142-3.358-7.5-7.5-7.5c-4.142,0-7.5,3.358-7.5,7.5V497H79.13V271.516    h305.646v24.566c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-24.566h24.564c13.545,0,24.564,11.02,24.564,24.564    V472.436z M497.001,424.338c0,13.546-11.02,24.565-24.564,24.565h-8.532v-49.129h33.096V424.338z M497.001,64.128h-24.566    c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h24.566v305.646h-33.097V296.08c0-21.816-17.749-39.564-39.564-39.564    H271.517V79.129h168.852c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5H271.517V39.564    c0-13.545,11.02-24.564,24.564-24.564h176.355c13.545,0,24.565,11.02,24.565,24.564V64.128z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M400.292,32.064h-32.065c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h32.065c4.142,0,7.5-3.358,7.5-7.5    C407.792,35.422,404.434,32.064,400.292,32.064z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M336.242,32.064h-0.08c-4.142,0-7.46,3.358-7.46,7.5c0,4.142,3.398,7.5,7.54,7.5c4.142,0,7.5-3.358,7.5-7.5    C343.742,35.422,340.384,32.064,336.242,32.064z"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M235.812,33.133L195.731,9.085c-3.554-2.132-8.159-0.979-10.29,2.572c-2.131,3.552-0.979,8.159,2.572,10.29l16.862,10.117    h-69.116c-57.177,0-103.694,46.517-103.694,103.694v69.116l-10.117-16.862c-2.131-3.551-6.738-4.704-10.29-2.572    c-3.552,2.131-4.704,6.738-2.572,10.29l24.048,40.081c1.355,2.259,3.797,3.641,6.431,3.641c2.634,0,5.076-1.382,6.431-3.641    l24.048-40.081c2.131-3.552,0.979-8.159-2.572-10.29c-3.553-2.132-8.159-0.979-10.29,2.572l-10.117,16.862v-69.116    c0-48.906,39.788-88.694,88.694-88.694h69.116l-16.862,10.117c-3.552,2.131-4.704,6.738-2.572,10.29    c1.406,2.344,3.89,3.642,6.438,3.642c1.313,0,2.644-0.345,3.852-1.07l40.081-24.048c2.259-1.355,3.641-3.797,3.641-6.431    C239.453,36.93,238.071,34.488,235.812,33.133z"
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: 1.1,
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      "transform": "rotate(90deg)"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

export default __webpack_public_path__ + "static/media/rotatePhone.aae28991.svg";
export { SvgComponent as ReactComponent };